/**
 * Studio Zuiver: <faq-page> (sections/faq-page.liquid). Category chips filter the question groups
 * client-side; the active category is mirrored in the URL hash (#verzending) so it can be linked.
 * Without JS all groups stay visible.
 */
class FaqPage extends HTMLElement {
  connectedCallback() {
    this.chips = [...this.querySelectorAll('.faq-page__chip')];
    this.groups = [...this.querySelectorAll('.faq-page__group')];
    if (!this.chips.length) return;
    this.chips.forEach((chip) => chip.addEventListener('click', () => this.select(chip.dataset.category, true)));
    const fromHash = decodeURIComponent(location.hash.replace(/^#faq-|^#/, ''));
    const known = this.groups.some((g) => g.dataset.category === fromHash);
    this.select(known ? fromHash : '', false);
    window.addEventListener('hashchange', this.#onHash);
  }

  disconnectedCallback() {
    window.removeEventListener('hashchange', this.#onHash);
  }

  #onHash = () => {
    const cat = decodeURIComponent(location.hash.replace(/^#faq-|^#/, ''));
    if (this.groups.some((g) => g.dataset.category === cat)) this.select(cat, false);
  };

  /**
   * @param {string} category - handleized category, '' for all
   * @param {boolean} pushHash - write the category to the URL
   */
  select(category, pushHash) {
    this.chips.forEach((chip) => {
      const active = chip.dataset.category === category;
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', String(active));
    });
    this.groups.forEach((group) => {
      group.hidden = category !== '' && group.dataset.category !== category;
    });
    if (pushHash) {
      const url = category ? `#faq-${category}` : location.pathname + location.search;
      history.replaceState(null, '', url);
    }
  }
}

if (!customElements.get('faq-page')) {
  customElements.define('faq-page', FaqPage);
}
